<template>
<div id="app">
  <div class="container">
    <div v-show="activeTab == 'main'">
    <app-menu></app-menu>
    <div id="hider">
    </div>
  </div>

  <div v-show="activeTab == 'plan'">
  <app-plan></app-plan>
  <div style="height: 75px;"></div>
</div>

  <div v-show="activeTab == 'calc'">
  <app-calc></app-calc>
  <div style="height: 75px;"></div>
</div>

<div v-show="activeTab == 'info'">
<app-author></app-author>
<div style="height: 75px;"></div>

</div>
</div>
<app-dock v-on:tabChanged="activeTab = $event"></app-dock>
</div>
</template>
<script>
export default {
name: 'app',
data () {
    return {
    activeWeek: ' ',
    activeTab: 'main',
    activeGroup: ' ',
    activeHref: ' ',
    acHref: ' '
  }
},
beforeMount: function() {
var currentHref = localStorage.getItem("currentGroup");
this.activeHref = currentHref
window.dataLayer = window.dataLayer || [];
}
}
</script>
<style>
.container {
width: 90vw;
margin: 0px auto;
}
.fade-enter-active, .fade-leave-active {
transition: opacity .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
opacity: 0;
}
.heading {
text-align: center;
font-size:  21px;
margin-top: 25px;
margin-bottom: 25px;
font-weight: 500;
}
</style>
<style scoped>
.ifNull img {
max-width: 350px;
width: 85%;
margin: 5px auto;
}
.ifNull {
display: -webkit-flex;
display: -moz-flex;
display: -ms-flex;
display: -o-flex;
display: flex;
height: 90vh;
-webkit-flex-direction: column;
-moz-flex-direction: column;
-ms-flex-direction: column;
-o-flex-direction: column;
flex-direction: column;
text-align: center;
justify-content: center;
color: #6d7173;
font-size: 17px;
font-weight: 600px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue